import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getAnalyticsSummary({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        reconAnalyticsSummary {
          title
          value
        }
      }`, params)
    .then(({ data }) => {
      const { reconAnalyticsSummary } = data || {};

      commit('setSummary', reconAnalyticsSummary);
      commit('toggleLoading', false);
    })
    .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-summary/store/actions.js